import Orderbook from 'src/components/Orderbook/Orderbook';
import { TradeForm } from 'src/components/TradeForm/TradeForm';
import useCurrentSettings from 'src/hooks/useCurrentSettings';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import { cj } from 'src/utils/classNames';

export default function MobileTradeFormAndOrderbook() {
	const selectedMarketType = useDriftStore(
		(s) => s.selectedMarket.current?.marketType
	);
	const activeMobileView = useDriftStore((s) => s.activeMobileView);

	const [{ showOrderbookOnMobileTradeView }] = useCurrentSettings();

	const showOrderbook =
		showOrderbookOnMobileTradeView &&
		// We also render an OB on the Chart view, and having two OB's in the DOM at
		// the same time a) is wasteful and b) confuses `useDynamicOrderbookDepth`.
		activeMobileView === 'trade';

	return (
		<div className="flex gap-x-xs py-xs text-text-default">
			{showOrderbook && (
				<div className="flex max-w-36 min-w-0 shrink grow-0 basis-36 overflow-hidden rounded-r-sm">
					<Orderbook isMini />
				</div>
			)}
			<div
				className={cj(
					'flex-1 bg-container-bg',
					showOrderbook && 'rounded-l-sm'
				)}
			>
				{selectedMarketType && (
					<TradeForm marketType={selectedMarketType} className="p-2" />
				)}
			</div>
		</div>
	);
}
